
import { useDispatch, useSelector } from "react-redux";
import { selectTournamentPaymentSettings } from "../../reducers/tournamentSlice";
import {
  addDonationToOrderThunk,
  removeDonationOrderItemThunk,
  selectRegistrationOrder,
  updateDonationItemThunk,
} from "../../reducers/registrationOrderSlice";
import DonationLineItem from "../events/donation-line-item";
import { getRouting } from "../../helpers/Converters";
import { eventBaseRoute } from "../../routes/event";
import { useTournament } from "../../hooks/tournamentHooks";
import { useNotificationAction, useNotifications } from "../../hooks/notificationHooks";
import { FULFILLED } from "../../app/api";
import { useGolfstatusNavigate } from "../../hooks/navigationHooks";

const TournamentDonationWidget = () => {
  const tournament = useTournament();
  const tournamentPaymentSettings = useSelector(
    selectTournamentPaymentSettings
  );
  const registrationOrder = useSelector(selectRegistrationOrder);

  const donation = registrationOrder?.donationOrderItems?.find?.(
    (d) => !d.roundUp
  );

  const {filteredNotifications} = useNotifications()
  const notifications = filteredNotifications(["addDonationToOrderThunk", "updateDonationItemThunk"])

  const navigate = useGolfstatusNavigate();
  const dispatch = useDispatch();

  useNotificationAction(FULFILLED,notifications,()=>{
    navigate(getRouting(eventBaseRoute, [tournament?.publicUrl, "donate"]));
  })

  const donationSelected = (amount) => {
    donate(amount)
  };

  const donate = (amount) => {
    if (donation?.id) {
      if (amount === "0") {
        dispatch(removeDonationOrderItemThunk(donation));
      } else {
        dispatch(updateDonationItemThunk({ ...donation, amount }));
      }
    } else {
      dispatch(addDonationToOrderThunk({ amount, registrationOrder }));
    }
  };

  return (
    <DonationLineItem
      {...tournament}
      {...tournamentPaymentSettings}
      donationSelected={donationSelected}
    />
  );
};

export default TournamentDonationWidget;
